import React from "react";
import Header from "./components/Header";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import Gallery from "./components/Gallery";
import Team from "./components/Team";
import TechTeam from "./components/TechTeam";
// import Form from "./components/Form";
import ParticleBackground from "./components/ParticleBackground";
import Footer from "./components/Footer";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <main>
          <Routes>
            <Route exact path="/" element={<AboutUs />} />
            <Route path="/TechTeam" element={<TechTeam />} />
            <Route path="/aboutUs" element={<AboutUs />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/team" element={<Team />} />
            {/* <Route path="/udaipur_trip" element={<Form />} /> */}
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
